export const ALLOW_CLIENT_LIST = ["mcgriff"];
